import React, { useEffect, useState, useRef } from "react";
import { ReactComponent as EDITLOGO } from "../../../assets/images/editgroup.svg";
import Input from "../../common/InputField";
import PhoneNumberInput from "../../common/PhoneInput";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { updateOnBoarding } from "../../../store/features/onBoardingUpdate";
import { GetBusinessDetail } from "../../../store/features/getBusinessDetail";
import { ReactComponent as Avatar } from "../../../assets/images/agentPic.svg";
import { CircularProgress } from "@mui/material";

function PersonalInformation() {
  const fileInputRef = useRef(null);
  const [logoUpload, setLogoUpload] = useState(null);
  const [image, setImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [businessName, setBusinessName] = useState("");
  const [businessEmail, setBusinessEmail] = useState("");
  const [businessAddress, setBusinessAddress] = useState("");
  const [websiteLink, setWebsiteLink] = useState("");
  const [phoneState, setPhoneState] = useState({
    phoneNumber: "",
    phoneNumberErrorMsg: "",
    phoneNumberInvalid: false,
    phoneStateValid: false,
  });

  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage
  );
  const t = useSelector(
    (state) => state.language.translations[currentLanguage]
  );

  const userData = useSelector((state) => state.loginToken);
  const dispatch = useDispatch();

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleLogoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setIsLoading(true);
      const fileURL = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => {
        setImage(file);
        setLogoUpload(fileURL);
        setIsLoading(false);
      };
      img.src = fileURL;
    }
  };

  const handlePhoneChange = (value) => {
    const phoneNumber = value.replace(/\D/g, "");
    if (phoneNumber.length >= 6 && phoneNumber.length <= 12) {
      setPhoneState({
        phoneNumber,
        phoneNumberErrorMsg: "",
        phoneNumberInvalid: false,
        phoneStateValid: true,
      });
    } else {
      let errorMsg = "";
      if (phoneNumber.length < 6) {
        errorMsg = t.PHONEERROR;
      } else if (phoneNumber.length > 12) {
        errorMsg = t.PHONEERROR;
      }
      setPhoneState({
        phoneNumber,
        phoneNumberErrorMsg: errorMsg,
        phoneNumberInvalid: true,
        phoneStateValid: false,
      });
    }
  };

  const getBusinessDetail = async () => {
    const listCoUserList = dispatch(
      GetBusinessDetail({ id: userData?.response?.user?.business_id })
    );
    listCoUserList
      .then(async (data) => {
        if (typeof data.payload === "undefined") {
          toast.error("Some Error Occured. Please try again later.");
        } else if (data?.payload?.status === 200) {
          const item = data?.payload?.data;
          console.log("item in personal information", item);
          setBusinessName(item.business_name);
          setBusinessEmail(item.business_email);
          setLogoUpload(item.business_logo);
          setBusinessAddress(item.business_address);
          setWebsiteLink(item.business_website_link);
          setPhoneState((prevState) => ({
            ...prevState,
            phoneNumber: item.business_phone,
          }));
        } else if (data?.payload?.status === 500) {
          toast.error("Some Error Occured. Please try again later.");
        } else if (data?.payload?.status === 401) {
          toast.error("Login Expired. Please login  and try again.");
        }
      })
      .catch(async (error) => {
        toast.error(error);
      });
  };

  useEffect(() => {
    getBusinessDetail();
  }, []);

  const handleSave = async () => {
    const data = {
      business_name: businessName,
      business_email: businessEmail,
      business_phone: phoneState.phoneNumber,
      business_address: businessAddress,
      business_website_link: websiteLink,
      business_logo: image,
    };

    const formData = new FormData();
    formData.append("business_name", data.business_name);
    formData.append("business_email", data.business_email);
    formData.append("business_phone", data.business_phone);
    formData.append("business_address", data.business_address);
    formData.append("business_website_link", data.business_website_link);
    formData.append("business_logo", data.business_logo);

    const loginUserDispatcher = dispatch(
      updateOnBoarding({
        id: userData?.response?.user?.business_id,
        formData,
      })
    );
    loginUserDispatcher
      .then(async (response) => {
        if (response.payload.status === 200) {
          toast.success("Profile information updated successfully");
          console.log("Success in onBoardingApi:", response);
        } else {
          toast.error("Some Error Occured. Please try again later.");
          console.error("Error response:", response);
        }
      })
      .catch((error) => {
        console.error("Error in onBoardingApi:", error);
      });
  };

  return (
    <div className="Personal-Information-Main-Container">

      <div className="Personal-Information">
        <div className="Personal-Info-Text-Container">
          <p className="Personal-Info-Text">Profile Information</p>
          <p className="Personal-Info-Subtext">
            Review and manage your profile.
          </p>
        </div>

        <div className="Avatar-Container">
          <div>
            <div className="Avatar-Img-Main">
              {!logoUpload || isLoading ? (
                <CircularProgress size={36} />
              ) : (
                <img
                  src={logoUpload}
                  alt="user01 Logo"
                  style={{
                    width: "56px",
                    height: "56px",
                    borderRadius: "32px",
                  }}
                />
              )}
              <div
                style={{ display: "flex", flexDirection: "column", gap: "4px" }}
              >
                <p className="Avatar-Text">Upload Logo</p>
                <p className="Avatar-Subtext">
                  Photo help your teammates recognize you
                </p>
              </div>
            </div>
          </div>
          <div>
            <input
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleLogoChange}
              ref={fileInputRef}
            />
            <button
              className="Change-Avatar-Button"
              type="button"
              onClick={handleButtonClick}
            >
              Change Logo
            </button>
          </div>
        </div>

        <div className="Personal-Information-Inputs">
          <div className="Spacing-Bottom">
            <Input
              title="Business Name"
              placeholder="Enter your business name"
              value={businessName}
              onChange={(e) => setBusinessName(e.target.value)}
            />
          </div>
          <div className="Spacing-Bottom">
            <Input
              title="Business Email"
              placeholder="Enter your email address"
              value={businessEmail}
              onChange={(e) => setBusinessEmail(e.target.value)}
              disable={true}
            />
          </div>
          <div className="Spacing-Bottom">
            <Input
              title="Website Link"
              placeholder="Enter your website link"
              value={websiteLink}
              onChange={(e) => setWebsiteLink(e.target.value)}
            />
          </div>

          <div className="Spacing-Bottom">
            <Input
              title="Business Address"
              placeholder="Enter your Business address"
              value={businessAddress}
              onChange={(e) => setBusinessAddress(e.target.value)}
            />
          </div>
          <div className="Spacing-Bottom">
            <PhoneNumberInput
              title="Phone Number"
              placeholder="Enter your phone number"
              value={phoneState.phoneNumber}
              onChange={(e) => handlePhoneChange(e)}
            />
          </div>
        </div>

        <button
          className="Personal-Information-Save-Button"
          type="button"
          onClick={handleSave}
        >
          Save Changes
        </button>
      </div>
    </div>
  );
}

export default PersonalInformation;
